<div class="choose-image-card" id="bca-choose-image">

  <!-- LEFT: placeholder when no image, actual image when selected -->
  <ng-container *ngIf="selectedFaceImage as image; else placeholder">
    <div class="image-preview" privacySensitive>
      <img class="animated pulse" [src]="image.imageAsBase64 | displayImage" />
    </div>
  </ng-container>
  <ng-template #placeholder>
    <div class="image-placeholder">
      <div class="placeholder-icon-wrapper">
        <nes-icon name="user"></nes-icon>
      </div>
    </div>
  </ng-template>

  <!-- RIGHT: title, description, button -->
  <div class="image-content">
    <nes-heading tag="h2" size="md" class="nes-mb-2 photo-card-heading">
      {{ (selectedFaceImage ? "USER_DATA.INPUT.PHOTO.LABEL_UPLOADED" : "USER_DATA.INPUT.PHOTO.LABEL") | translate }}
    </nes-heading>
    <nes-text size="md" class="nes-mb-4">
      {{ (selectedFaceImage ? "USER_DATA.INPUT.PHOTO.UPLOAD_UPLOADED" : "USER_DATA.INPUT.PHOTO.UPLOAD") | translate }}
    </nes-text>

    <ng-container *ngIf="selectedFaceImage; else uploadButton">
      <button
        class="btn-choose-another-photo"
        [attr.data-cypress]="'delete_image'"
        type="button"
        (click)="delete.emit()"
      >
        {{ "USER_DATA.BUTTON.MAKE_PHOTO_NEW" | translate }}
      </button>
    </ng-container>
    <ng-template #uploadButton>
      <nes-button
        nes-id="open_upload_photo_dialog"
        id="open_upload_photo_dialog"
        (click)="openDialog.emit()"
        [cypress]="'choose_image'"
        type="button"
        class="btn-upload-main"
      >
        {{ "USER_DATA.BUTTON.CHOOSE_PHOTO" | translate }}
      </nes-button>
    </ng-template>
  </div>

</div>
<div *ngIf="imageRequiredError">
  <nes-error-message>
    {{ "USER_DATA.INPUT.PHOTO.ERROR_REQUIRED" | translate }}
  </nes-error-message>
</div>

